export default "__VITE_ASSET__D5ot4eeW__"